var exports = {
  "Cz": "expandableContent__0_lr6T",
  "Xf": "paddingInlineNone__IocO_n",
  "y": "expandableWrapper__noG29t",
  "Av": "isExpanded__BtNx4K",
};

module.exports = exports;
